export const API_KEY_SCOPE_OPTIONS = [
  { value: "contacts:read", label: "Read contacts" },
  { value: "contacts:write", label: "Write contacts" },
  { value: "orders:read", label: "Read orders" },
  { value: "orders:write", label: "Write orders" },
] as const;

export function isValidApiKeyScope(scope: string): boolean {
  return API_KEY_SCOPE_OPTIONS.some((option) => option.value === scope);
}

export function maskApiKey(key: string): string {
  if (key.length <= 12) {
    return "••••••••";
  }

  return `${key.slice(0, 7)}...${key.slice(-4)}`;
}
